import { FlowDurationUnits, FlowFhirResourceType, FlowHieDocumentFormat } from 'flow-schema';
import { z } from 'zod';

import { oneOrMany } from '../../../utils.js';
import { DurationSchemaWithMax } from '../base/baseSchema.js';

export const BaseHieGetDocumentsBlockConfigSchema = z.object({
  sourceBlock: z.object({
    sourceBlockName: z.string(),
  }),
  timeout: DurationSchemaWithMax('timeout', {
    value: 30,
    units: FlowDurationUnits.Minutes,
  }),
});

export const BaseConsolidatedBlockConfigSchema = BaseHieGetDocumentsBlockConfigSchema.extend({
  resources: oneOrMany(z.enum(FlowFhirResourceType)).default([]),
  dateTo: z.string().optional(),
  dateFrom: z.string().optional(),
});

export const ConsolidatedJsonConfigSchema = BaseConsolidatedBlockConfigSchema.extend({
  documentFormat: z.enum([FlowHieDocumentFormat.ConsolidatedData]),
  includeRelatedRecords: z.boolean().default(false),
});

export type ConsolidatedJsonConfig = z.infer<typeof ConsolidatedJsonConfigSchema>;

export const ConsolidatedRenderedConfigSchema = BaseConsolidatedBlockConfigSchema.extend({
  documentFormat: z.enum([
    FlowHieDocumentFormat.ConsolidatedDataPdf,
    FlowHieDocumentFormat.ConsolidatedDataHtml,
  ]),
});

export const BulkDownloadUrlsConfigSchema = BaseHieGetDocumentsBlockConfigSchema.extend({
  documentFormat: z.literal(FlowHieDocumentFormat.BulkDownloadUrls),
});
